var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import kfetch from '@kareo/kfetch';
import featureSetAreas from 'shared-assets/lib/sdk/featureSetAreas';
import rollbar from 'shared-assets/src/errors/errors';
import featureToggles from "shared-assets/lib/sdk/featureToggles";
var headers = {
    'Content-Type': 'application/json',
};
var CLINICAL_RECOMMENDATION_UI_FT = 'dark-feature.clinical-recommendation-ui';
var getClinicalRecommendationEndpoint = function () { return __awaiter(void 0, void 0, void 0, function () {
    var defaultEndpoint, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                defaultEndpoint = 'facesheet-ui';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, featureToggles.isEnabled(CLINICAL_RECOMMENDATION_UI_FT)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, !!response ? 'clinical-recommendation-ui' : defaultEndpoint];
            case 3:
                e_1 = _a.sent();
                rollbar.error(e_1);
                return [2 /*return*/, defaultEndpoint];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var getProblems = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/patient-problems-ui/api/patient/" + patientId + "/problems?activeOnly=true", {
                headers: __assign({ 'X-API-VERSION': '2' }, headers),
            })];
    });
}); };
export var getHistorySummary = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/history")];
    });
}); };
export var getHistorySummaryUpdated = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/patient-history-ui/api/patient/" + patientId + "/history")];
    });
}); };
export var getLabs = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/labs-ui/api/LabOrder/Summaries", {
                method: 'POST',
                body: JSON.stringify({ pageSize: 10, pageNo: 1, patientId: patientId }),
                headers: headers,
            })];
    });
}); };
export var getMedications = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/medications-ui/api/patient-medications/list", {
                method: 'POST',
                body: JSON.stringify({
                    orderBy: 'UPDATE_DATE',
                    patientId: patientId,
                    sortDirection: 'desc',
                    isActive: true,
                    state: 'ACTIVE',
                    deltaMark: 0,
                    isError: false,
                }),
                headers: headers,
            })];
    });
}); };
export var getLastVitals = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/patient-vitals-ui/api/patient/" + patientId + "/latestVitals")];
    });
}); };
export var getLatestVitals = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/vitals")];
    });
}); };
export var getClinicalRecommendations = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getClinicalRecommendationEndpoint()];
            case 1:
                endpoint = _a.sent();
                return [2 /*return*/, fetch("/" + endpoint + "/api/recommendation/patient/" + patientId)];
        }
    });
}); };
export var updateClearedRecommendations = function (patientId, clearedRecommendationList) { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getClinicalRecommendationEndpoint()];
            case 1:
                endpoint = _a.sent();
                return [2 /*return*/, kfetch("/" + endpoint + "/api/recommendation/patient/" + patientId + "/cleared", {
                        body: JSON.stringify(clearedRecommendationList),
                        method: 'PUT',
                    })];
        }
    });
}); };
export var getPatientPortalInfo = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/portalProfile")];
    });
}); };
// Using fetch for access to full response with headers and status code for resilience caching
export var getAllergies = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/allergies")];
    });
}); };
export var getPracticeNoteTypes = function (patientId, signal) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/notes-ui/api/Note/NoteTypes/patient/" + patientId, {
                signal: signal,
            })];
    });
}); };
export var getDefaultNoteType = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/notes-ui/api/Note/NoteTypes/default")];
    });
}); };
export var getFacesheetConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/configurations")];
    });
}); };
export var updateFacesheetConfiguration = function (facesheetConfiguration) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/configurations", {
                body: JSON.stringify(facesheetConfiguration),
                method: 'PUT',
            })];
    });
}); };
export var getFacesheetConfigurationForPractice = function (practiceId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/configurations/practice/" + practiceId)];
    });
}); };
export var getAhrqFlag = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/facesheet-ui/api/Facesheet/ahrqFlag")];
    });
}); };
export var getPatientAppointments = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("/dashboard-calendar-ui/api/Appointment/patients/" + patientId + "/nextAndLastAppointments")];
    });
}); };
export var fetchPracticePermissions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var clinicalProductEnabled, billingProductEnabled, recallEnabled, documentsEnabled, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                clinicalProductEnabled = false;
                billingProductEnabled = false;
                recallEnabled = false;
                documentsEnabled = false;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, featureSetAreas.getFeatureSetArea('feature-set.product.clinical')];
            case 2:
                clinicalProductEnabled = (_a.sent()).enabled;
                return [4 /*yield*/, featureSetAreas.getFeatureSetArea('feature-set.product.billing')];
            case 3:
                billingProductEnabled = (_a.sent()).enabled;
                return [4 /*yield*/, featureSetAreas.getFeatureSetArea('feature-set.area.patient-recall')];
            case 4:
                recallEnabled = (_a.sent()).enabled;
                return [4 /*yield*/, featureSetAreas.getFeatureSetArea('feature-set.area.documents')];
            case 5:
                documentsEnabled = (_a.sent()).enabled;
                return [3 /*break*/, 7];
            case 6:
                e_2 = _a.sent();
                rollbar.error(e_2);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/, {
                    clinicalProductEnabled: clinicalProductEnabled,
                    billingProductEnabled: billingProductEnabled,
                    recallEnabled: recallEnabled,
                    documentsEnabled: documentsEnabled,
                }];
        }
    });
}); };
export var getPatientStatus = function (patientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kfetch("/patient-problems-ui/api/patient/" + patientId + "/status")];
    });
}); };
